import ReportIncoming from '@/models/ReportIncoming/ReportIncoming';

export default class ReportIncomingFilter {

	constructor() {
		/*APP_FILTER_DEFINITION*/
		this.filterSupplier = '';
		this.filterPart = '';
		this.filterPurchaseOrderNumber = '';
		this.filterPartGoodReceiptDateFrom = '';
		this.filterPartGoodReceiptDateTo = '';
		this.filterCustomer = '';
		this.filterPartSpecification = '';
		this.filterPartName = '';
		this.tempId = '';
		this.grDateFrom = '';
		this.grDateTo = '';
		this.suratJalan = '';
		this.purchaseOrderNumber = '';
		this.partNumber = '';
		this.partSpecification = '';
		this.qtyActual = '';
		this.uom = '';
		this.customerCode = '';
		this.supplierCode = '';
		this.supplierCaseNumber = '';
		this.remark = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
			/*APP_APP_FILTER_CRITERIA*/
			filterSupplier: '0',
			filterPart: '0',
			filterPurchaseOrderNumber: '0',
			filterPartGoodReceiptDateFrom: '0',
			filterPartGoodReceiptDateTo: '0',
			filterCustomer: '0',
			filterPartSpecification: '0',
			tempId: '0',
			grDateFrom: '0',
			grDateTo: '0',
			suratJalan: '0',
			purchaseOrderNumber: '0',
			partNumber: '0',
			partSpecification: '0',
			qtyActual: '0',
			uom: '0',
			customerCode: '0',
			supplierCode: '0',
			supplierCaseNumber: '0',
			remark: '0',
			isFromUpload: '0',
			isSavedToBackend: '0',
			/*END_APP_FILTER_CRITERIA*/
		};
	}

}